<div id="editUserProfile">
  <button id="closeEditUserProfileBtn" class="closeBtn" (click)="closeEditUserProfile()">
    <mat-icon>close</mat-icon>
  </button>

  @if (editAction === userProfileAction.ChangePassword) {
  <div>
    <h5 class="editUserProfileLabel">{{ selText.changePassword }}</h5>
    <form [formGroup]="changePasswordForm" (ngSubmit)="onChangePasswordSubmit()">
      <!-- Current Password -->
      <div>
        <mat-form-field appearance="outline">
          <mat-label>{{ selText.currentPassword }}</mat-label>
          <input matInput formControlName="currentPassword" [type]="currentPasswordFieldType"
            (click)="$event.stopPropagation()">
          <button mat-icon-button matSuffix tabindex="-1" (click)="togglePasswordVisibility($event, 'current')"
            [attr.aria-label]="currentPasswordFieldType === 'password' ? selText.showPassword : selText.hidePassword"
            matTooltip="{{ currentPasswordFieldType === 'password' ? selText.showPassword : selText.hidePassword }}">
            <mat-icon>{{ currentPasswordFieldType === 'text' ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <!-- New Password -->
      <div>
        <mat-form-field appearance="outline" matTooltip="{{selText.passwordRequirements}}">
          <mat-label>{{ selText.newPassword }}</mat-label>
          <input matInput formControlName="newPassword" [type]="newPasswordFieldType" (click)="$event.stopPropagation()">
          <button mat-icon-button matSuffix tabindex="-1" (click)="togglePasswordVisibility($event, 'new')"
            [attr.aria-label]="newPasswordFieldType === 'password' ? selText.showPassword : selText.hidePassword"
            matTooltip="{{ newPasswordFieldType === 'password' ? selText.showPassword : selText.hidePassword }}">
            <mat-icon>{{ newPasswordFieldType === 'text' ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (changePasswordForm.get('newPassword')?.hasError('minlength')) {
          <mat-error>
            {{selText.passwordTooShort}}
          </mat-error>
          }
        </mat-form-field>
      </div>
      <!-- Confirm New Password -->
      <div>
        <mat-form-field appearance="outline">
          <mat-label>{{ selText.confirmPassword }}</mat-label>
          <input matInput formControlName="confirmPassword" [type]="newPasswordFieldType"
            (click)="$event.stopPropagation()">
          <button mat-icon-button matSuffix tabindex="-1" (click)="togglePasswordVisibility($event, 'new')"
            [attr.aria-label]="newPasswordFieldType === 'password' ? selText.showPassword : selText.hidePassword"
            matTooltip="{{ newPasswordFieldType === 'password' ? selText.showPassword : selText.hidePassword }}">
            <mat-icon>{{ newPasswordFieldType === 'text' ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div class="buttonWrapper">
        <button mat-raised-button color="primary" type="submit" [disabled]="!changePasswordForm.valid">{{
          selText.submit}}</button>
        <button mat-raised-button color="warn" type="button" (click)="closeEditUserProfile()">
          {{ selText.cancel}}
        </button>
        </div>
        </form>
        </div>
  }
</div>